import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";
import {
  getAllBaskets,
  encryptRSA,
  decryptAES,
  decrypttRSA,
  verifyOTP,
  savePreLoginData,
  encryptAES,
  resendOTP,
  allSectionsMeta
} from "../actions";
import BasketCard from "../BasketCard";
import "./style.scss";
import Authentication from "../Common/Authentication";
import { closePopup, openPopup } from "../../../general/Modal/action";
import { MODALS } from "../../../general/Modal/constants";
import moment from "moment";
import ENV_CONFIG from "../../../../../config/environment";
import NoContent from "../../../general/NoContent";
import { ACTION } from "../constants";
import SocialShare from "../../../general/socials";
import cookie from 'react-cookies';
import { checkIframeContent,getRouting } from "../../../../../utils/common";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";

const BasketDetails = (props) => {
  const {
    location,
    getAllBaskets,
    investmentBasket,
    verifyOTP,
    savePreLoginData,
    resendOTP,
    closePopup,
    openPopup,
    allSectionsMeta,
    basketMeta
  } = props;

  const getQueryParams = () => {
    // this func will return an object whose keys represent query keys and value represemts value mapped with queries
    // {journey : "investmentPersonality"}
    var queryParam = location.search;
    queryParam = queryParam.slice(1);
    var key = queryParam.split("=")[0];
    var value = queryParam.split("=")[1];
    if(key == 'journeyPage'){
      return value;
    }
    return '0';
  };

  const currentUrl = location.pathname.split("/")[2] ? location.pathname.split("/")[2] : '';
  const [basketData, setBasketData] = useState([]);
  const [schemeData, setSchemeData] = useState([]);
  const [durationValues, setDurationValues] = useState({});
  const [potentialEquityExposure, setPotentialEquityExposure] = useState(null);
  const [selectedBasket, setSelectedBasket] = useState(null);
  const [basketDescription, setBasketDescription] = useState(null);
  const [journeyPage, setJourneyPage] = useState(getQueryParams() == '1' ? 1:0);
  const [kycData, setKycData] = useState(null);
  const [OTP, setOtp] = useState(null);

  const aboutJourney =
    " Your investing personality determines the type of investor you are and how you should make your investments by taking into account various factors like age, financial history, circumstances and your investment goals";

  const [uuid, setUuid] = useState(null);
  const [redirectionLink, setRedirectionLink] = useState(null);
  const [share, setShare] = useState(false);
  const [authvalues, setAuthvalues] = useState({
    pan: "",
    dob: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    if (currentUrl) {
      allSectionsMeta({}, currentUrl);
    }
  }, [currentUrl]);

  useEffect(() => {
    const getData = async () => {
      let response = await getAllBaskets();
    };
    getData();
  }, [currentUrl]);


  useEffect(() => {
    let schemesArray = [];
    if (investmentBasket.allBaskets.apiLoaded) {
      setBasketData(
        investmentBasket.allBaskets.data.basketDetailDTOList.filter(
          (item) =>
            item.basketName.replace(/\s+/g, "-").toLowerCase() !==
            location.pathname.split("/")[2].toLowerCase()
        )
      );
      schemesArray =
        investmentBasket.allBaskets.data.basketDetailDTOList.filter(
          (item) =>
            item.basketName.replace(/\s+/g, "-").toLowerCase() ===
            location.pathname.split("/")[2].toLowerCase()
        );
      setSchemeData(schemesArray[0].schemesInBasket);
      setPotentialEquityExposure(schemesArray[0].potentialEquityExposure);
      setSelectedBasket(schemesArray[0].basketName);
      setBasketDescription(schemesArray[0].basketDescription);
    }
  }, [investmentBasket.allBaskets]);
  useEffect(() => {
    if (authvalues.pan && authvalues.dob) {
      let object = {
        pan: authvalues.pan,
        dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
        email: authvalues.email,
        mobile: authvalues.mobile,
      };
      setRedirectionLink(encryptAES(JSON.stringify(object)));
    }
  }, [authvalues]);

  useEffect(() => {
    schemeData &&
      schemeData.map((item) => {
        setDurationValues((currentValue) => ({
          ...currentValue,
          [item.schemeName.split("-")[0].replace(/\s+/g, "-").toLowerCase()]:
            "11",
        }));
      });
  }, [schemeData]);

  useEffect(() => {
    if (
      investmentBasket.otpVerificationData.apiLoaded &&
      investmentBasket.otpVerificationData.data &&
      investmentBasket.otpVerificationData.data.uuid
    ) {
      setUuid(investmentBasket.otpVerificationData.data.uuid);
      let basketDetails = {};
      if (investmentBasket.allBaskets && investmentBasket.allBaskets.data) {
        investmentBasket.allBaskets.data.basketDetailDTOList.forEach((ele) => {
          if (ele.basketName === selectedBasket) {
            basketDetails = ele;
          }
        });
        const saveDetails = async () => {
          let params = {
            panNumber: authvalues.pan,
            journey: ACTION.JOURNEY.INVESTMENT_BASKET_JOURNEY,
            step: "FIRST",
            basket: selectedBasket ? true : false,
            basketDetails: basketDetails,
            nriFlag : cookie.load("taxData"),
          };
          let response = await savePreLoginData(
            encryptAES(JSON.stringify(params)),
            investmentBasket.otpVerificationData.data.uuid
          );
          response && console.log(response);
        };
        saveDetails();
      }
    }
  }, [investmentBasket.otpVerificationData]);

  const onChange = () => {
    setDurationValues((currentValue) => ({
      ...currentValue,
      [event.target.name]: event.target.value,
    }));
  };

  const onSubmit = (authValues, kycData) => {
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: authValues.pan,
      dob: authValues.dob,
      mobile: authValues.mobile,
      email: authValues.email,
    }));
    if (kycData && kycData.data && kycData.data.kycVerifiedFlag) {
      setKycData(kycData);
      let modalData = {
        closeAction: closePopup,
        modalClass: "verify-otp-modal",
        maskedMobile:
          kycData && kycData.data && kycData.data.maskedMobile
            ? kycData.data.maskedMobile
            : "",
        maskedEmail:
          kycData && kycData.data && kycData.data.maskedEmail
            ? kycData.data.maskedEmail
            : "",
        onOtpSubmit,
        verifyOTP,
        resendOTP,
        secretLink: kycData && kycData.data && kycData.data.secretLink,
        dob: authValues.dob,
        pan: authValues.pan,
        journey: ACTION.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        registrationType:
          kycData && kycData.data && kycData.data.registrationType,
        encrypt: encryptAES,
        decrypt: decryptAES,
      };
      openPopup(MODALS.VERIFY_OTP, modalData);
    } else setJourneyPage(2);
  };

  const onOtpSubmit = (OTP) => {
    closePopup();
    setOtp(OTP);
  };

  const onInvestBasket = (data) => {
    setSelectedBasket(data);
    setJourneyPage(1);
  };

  const onBack = () => {
    setJourneyPage(0);
  };

  return (
    <div className="wrapper">
      <div className="investment-basket-journeys investment-basket-equity-basket main-section clearfix">
        {basketMeta && basketMeta.data && basketMeta.data.meta && <Helmet>
          <title>{basketMeta.data.meta.title}</title>
          <meta name="description" content={basketMeta.data.meta.description} />
          <meta name="keywords" content={basketMeta.data.meta.keywords} />
          <meta property="og:title" content={basketMeta.data.meta.og_title} />
          <meta property="og:description" content={basketMeta.data.meta.description} />
          <meta property="og:image" content={basketMeta.data.meta.og_image} />
          <meta property="og:url" content={basketMeta.data.meta.og_url} />
        </Helmet>}
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex dropdowncls">
              <div className="dropdown me-auto">
                <div
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <h1>
                  {basketMeta && basketMeta.data && basketMeta.data.title.split(' ').slice(0, -1).join(' ')} 
                  <span className='last-word ms-1'>
                    {basketMeta && basketMeta.data && basketMeta.data.title.split(' ').slice(-1)}
                  </span>
                  </h1>
                </div>
              </div>
                <nav
                  aria-label="breadcrumb"
                  className="align-self-center breadCrumbCust d-md-inlin"
                >
                  <ol className="breadcrumb mb-0">
                    {checkIframeContent() && <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>}
                    <li className="breadcrumb-item">
                      <Link to={getRouting("/product-solutions/investment-basket")}>Product & Solutions</Link>
                    </li>
                    <li
                      className="breadcrumb-item active breadcolor"
                      aria-current="page"
                    >
                      {basketMeta && basketMeta.data && basketMeta.data.title}
                    </li>
                  </ol>
                </nav>
            </div>
          </div>
        </section>
        {investmentBasket.allBaskets.apiLoaded ? (
          <div className="container">
            {journeyPage === 0 && (
              <div className="equity-basket">
                <div className="equity-top-bar">
                  {basketDescription && (
                    <p className="equity-text">{basketDescription}</p>
                  )}
                  {checkIframeContent () && <div className="equity-buttons">
                    <span className="share" onClick={() => setShare(!share)}>
                      <img
                        src="/images/investment-basket/investment-basket/ShareIcon.svg"
                        className="equity-share-icon"
                        alt="shareIcon"
                      />
                      {share && <SocialShare />}
                    </span>
                    <button
                      className="equity-invest-button"
                      onClick={() => setJourneyPage(1)}
                    >
                      Invest Now
                    </button>
                  </div>}
                </div>
                <div className="equity-fund-cards">
                  {schemeData &&
                    schemeData.map((item, index) => {
                      return (
                        <div className="fund-card" key={index}>
                          <div className="fund-card-content">
                            <div className="fund-card-head">
                              <div className="fund-card-title">
                                {item.schemeName}
                              </div>
                            </div>
                            <div className="fund-card-body">
                              {durationValues && (
                                <div className="fund-card-duration">
                                  <div className="input">
                                    <input
                                      type="radio"
                                      value={1}
                                      name={item.schemeName
                                        .split("-")[0]
                                        .replace(/\s+/g, "-")
                                        .toLowerCase()}
                                      onChange={onChange}
                                    />
                                    <span>1 year</span>
                                  </div>

                                    <div className="input">
                                      <input
                                        type="radio"
                                        value={3}
                                        name={item.schemeName
                                          .split("-")[0]
                                          .replace(/\s+/g, "-")
                                          .toLowerCase()}
                                        onChange={onChange}
                                      />
                                      <span>3 years</span>
                                    </div>
                                  
                                  <div className="input">
                                    <input
                                      type="radio"
                                      value={5}
                                      name={item.schemeName
                                        .split("-")[0]
                                        .replace(/\s+/g, "-")
                                        .toLowerCase()}
                                      onChange={onChange}
                                    />
                                    <span>5 years</span>
                                  </div>
                                  <div className="input">
                                    <input
                                      type="radio"
                                      value={10}
                                      name={item.schemeName
                                        .split("-")[0]
                                        .replace(/\s+/g, "-")
                                        .toLowerCase()}
                                      onChange={onChange}
                                    />
                                    <span>10 years</span>
                                  </div>
                                  <div className="input">
                                    <input
                                      type="radio"
                                      value={11}
                                      name={item.schemeName
                                        .split("-")[0]
                                        .replace(/\s+/g, "-")
                                        .toLowerCase()}
                                      onChange={onChange}
                                      defaultChecked
                                    />
                                    <span>Since Inception</span>
                                  </div>
                                </div>
                              )}
                              {durationValues && (
                                <div className="fund-card-details">
                                  <div className="details-annual">
                                    <p className="details-title">CAGR</p>
                                    <p className="details-percent">
                                      {
                                        item.annualisedReturns[
                                          durationValues[
                                            item.schemeName
                                              .split("-")[0]
                                              .replace(/\s+/g, "-")
                                              .toLowerCase()
                                          ]
                                        ] !== 0 ?
                                        item.annualisedReturns[
                                          durationValues[
                                            item.schemeName
                                              .split("-")[0]
                                              .replace(/\s+/g, "-")
                                              .toLowerCase()
                                          ]
                                        ]:''
                                      }
                                      {item.annualisedReturns[
                                        durationValues[
                                          item.schemeName
                                            .split("-")[0]
                                            .replace(/\s+/g, "-")
                                            .toLowerCase()
                                        ]
                                      ] === 0 || item.annualisedReturns[
                                        durationValues[
                                          item.schemeName
                                            .split("-")[0]
                                            .replace(/\s+/g, "-")
                                            .toLowerCase()
                                        ]
                                      ] === undefined
                                        ? "NA"
                                        : item.annualisedReturns[
                                            durationValues[
                                              item.schemeName
                                                .split("-")[0]
                                                .replace(/\s+/g, "-")
                                                .toLowerCase()
                                            ]
                                          ] && "%"}
                                    </p>
                                  </div>
                                  <div className="details-benchmarks">
                                    <p className="details-title">
                                      Benchmark Return
                                    </p>
                                    <p className="details-percent">
                                      {
                                        item.benchmarkReturns[
                                          durationValues[
                                            item.schemeName
                                              .split("-")[0]
                                              .replace(/\s+/g, "-")
                                              .toLowerCase()
                                          ]
                                        ] !== 0 ?

                                        item.benchmarkReturns[
                                          durationValues[
                                            item.schemeName
                                              .split("-")[0]
                                              .replace(/\s+/g, "-")
                                              .toLowerCase()
                                          ]
                                        ]:''
                                      }
                                      {item.benchmarkReturns[
                                        durationValues[
                                          item.schemeName
                                            .split("-")[0]
                                            .replace(/\s+/g, "-")
                                            .toLowerCase()
                                        ]
                                      ] === 0 || item.benchmarkReturns[
                                        durationValues[
                                          item.schemeName
                                            .split("-")[0]
                                            .replace(/\s+/g, "-")
                                            .toLowerCase()
                                        ]
                                      ] == undefined
                                        ? "NA"
                                        : item.benchmarkReturns[
                                            durationValues[
                                              item.schemeName
                                                .split("-")[0]
                                                .replace(/\s+/g, "-")
                                                .toLowerCase()
                                            ]
                                          ] && "%"}
                                    </p>
                                  </div>
                                </div>
                              )}

                              {
                                item.allocation ? (
                                  <div className="allocate-details mt-2">
                                    {`${item.allocation}% Basket Allocation`}
                                  </div>
                                ) : ""
                              }

                              <div className="details-description">
                                {item.schemeDescription}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {
                  <div className="equity-exposure">
                    <p className="exposure-text">
                      Potential Equity Exposure : {potentialEquityExposure}%
                    </p>
                  </div>
                }
                <div className="other-baskets">
                  <div className="other-baskets-head">
                    Other Investment Baskets
                  </div>
                  <div className="basket-card">
                    {basketData &&
                      basketData.map((item, index) => (
                        <BasketCard
                          item={item}
                          key={index}
                          onInvestBasket={onInvestBasket}
                        />
                      ))}
                  </div>
                </div>

                <div className="disclaimer">
                  <div className="disclaimer-head">
                    <span>Disclaimer:</span>
                  </div>
                  <div className="disclaimer-text">
                    <p className="disclaimer-text-top">
                      For Complete details of the schemes including Riskometer, product label, scheme related documents or to see other schemes offered by HDFC Mutual Fund, refer to the product pages <a href="/product-solutions">click here</a>.
                      <br /> 
                      The information contained herein is to help you to plan and invest for your financial goal based on your risk profile in a diversified and convenient manner.  The scheme(s) recommended are only suggestions and there is no guarantee of achievement of your goals. Investors are free to choose other schemes and proportions for their investments. Investors may invest in different schemes by logging in separately. Investment in each scheme will be distinct and governed by the terms and conditions of that scheme.
                    </p>
                    <br /> 
                    <p className="disclaimer-text-bottom">
                      Investors are requested to note that the above investment suggestions should not be construed as financial planning / investment advice by HDFC Mutual Fund/ HDFC AMC. The above suggestions do not in any manner, indicate or imply either the quality of any particular Scheme or guarantee any specific performance/returns. It does not have regard to specific investment objectives, financial situation and the particular needs of any specific person. The information/ data herein alone is not sufficient and should not be used for the development or implementation of an investment strategy. Neither HDFC AMC and HDFC Mutual Fund nor any person connected with them, accepts any liability arising from the use of information herein. Investor before acting on any information herein should make his/her/their own investigation and seek appropriate professional advice and shall alone be fully responsible / liable for any decision taken on the basis of information contained herein.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {journeyPage === 1 && (
              <div className="content-section clearfix">
                <p className="description">{aboutJourney}</p>
                <Authentication
                  onSubmit={onSubmit}
                  authValues={authvalues}
                  setJourneyPage={setJourneyPage}
                  onBack={onBack}
                />
              </div>
            )}
            {journeyPage === 2 && (
              <div className="not-kyc-verified">
                <p className="kycPage-title">Welcome to the HDFC Family!</p>
                <p>Kindly complete your KYC to start your investment journey</p>
                <a
                  href={`${ENV_CONFIG.INVESTOR_BASE_URL}/ekyc?prefill=${redirectionLink}`}
                  target="_blank"
                  rel="noreferrer"
                  className="complete-kyc"
                >
                  Complete KYC
                </a>
              </div>
            )}
            {journeyPage === 3 && (
              <div className="recommendation">
                <div className="basket">
                  <div>
                    <h4>Selected Basket</h4>
                    <p>{selectedBasket}</p>
                  </div>
                </div>
                <a
                  href={
                    investmentBasket.otpVerificationData &&
                      investmentBasket.otpVerificationData.data &&
                      investmentBasket.otpVerificationData.data.uuid
                      ? `${ENV_CONFIG.INVESTOR_BASE_URL}/invest-now?id=${investmentBasket.otpVerificationData.data.uuid}`
                      : ""
                  }
                  target="_blank"
                  rel="noreferrer"
                  className="submit start-investing"
                >
                  Start Investing
                </a>
              </div>
            )}
          </div>
        ) : (
          <NoContent />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  investmentBasket: state.ProductSolution.home,
  basketMeta: state.ProductSolution.home.metaAllBaskets,
});

const mapDispatchToProps = (dispatch) => ({
  getAllBaskets: bindActionCreators(getAllBaskets, dispatch),
  verifyOTP: bindActionCreators(verifyOTP, dispatch),
  savePreLoginData: bindActionCreators(savePreLoginData, dispatch),
  resendOTP: bindActionCreators(resendOTP, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  allSectionsMeta: bindActionCreators(allSectionsMeta, dispatch),
});

const BasketDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BasketDetails);

export default BasketDetailsContainer;
